<template>
    <div class="devices-list__block" v-if="deviceData">
        <device-status :device="deviceData" :showLocation="showLocation" :edit="edit"/>
        <v-layout row class="devices-list__block__title" :class="{'device-btns-edit': edit}">
            <device-title :device="deviceData"></device-title>
            <div class="btn-group">
                <v-flex class="btn-block">
                    <div class="d-inline-flex" v-if="deviceData.state != null">
                        <v-switch
                            v-model="deviceState"
                            inset
                            dense
                            hide-details
                            class="pa-0"
                            @click="changeDeviceSwitch"
                            :loading="loading"
                            :disabled="deviceData.disabled"
                            color="#FF8484"
                            v-if="free"
                        ></v-switch>
                        <device-switch-disabled :device-state="deviceData.state" :name="deviceData.uid" v-else :not-free="!free"></device-switch-disabled>
                    </div>
                </v-flex>
            </div>
        </v-layout>
        <div class="main-text mt-3">
            <v-slider
                v-model="deviceData.state.value"
                :tick-labels="tickLabels"
                ticks=""
                min="18"
                max="28"
                class="warm-floor-slider"
                dense
                hide-details
                @change="changeDeviceSlider"
                :readonly="!free || deviceData.disabled"
                v-if="deviceData.state"
            >
            </v-slider>
        </div>
    </div>
</template>

<script>
import { LOADING_TIMEOUT } from "@/utils/constants.js";
export default {
    name: "WarmFloorDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
        free: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
            deviceStateOldValue: null,
            deviceState: false,
            tickLabels: ['18', '', '20', '', '22', '', '24', '', '26', '', '28',],
            loading: false,
            disabledTimeout: null,
        };
    },
    created() {
        this.deviceData = this.device;
        this.deviceState = this.deviceData.state ? this.deviceData.state.value ? true : false : false;
        this.deviceStateOldValue = JSON.parse(JSON.stringify(this.deviceData.state));
    },
    beforeDestroy() {
        if (this.disabledTimeout) {
            clearTimeout(this.disabledTimeout);
        }
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
                this.loading = false;
                this.deviceState = this.deviceData.state ? this.deviceData.state.value ? true : false : false;
                if (this.disabledTimeout) {
                    clearTimeout(this.disabledTimeout);
                    this.deviceData.disabled = false;
                }
            }
        },
        "deviceData.state": {
            handler: function(val, old) {
                if (val != old && this.deviceData.state.value != this.deviceStateOldValue.value) {
                    this.deviceStateOldValue = old;
                }
            },
            deep: true,
        },
    },
    methods: {
        changeDeviceSwitch() {
            if (this.deviceState) {
                this.deviceData.state.value = 28;
            } else {
                this.deviceData.state.value = 0;
            }
            this.changeDeviceValue();
        },
        changeDeviceSlider() {
            setTimeout(() => {
                this.changeDeviceValue();
            }, 1000);
        },
        changeDeviceValue() {
            this.loading = true;
            this.deviceData.disabled = true;
            if (this.disabledTimeout) {
                clearTimeout(this.disabledTimeout);
            }
            this.disabledTimeout = setTimeout(() => {
                this.deviceData.disabled = false;
                this.loading = false;
                this.deviceData.state = this.deviceStateOldValue;
            }, LOADING_TIMEOUT);
            this.$http.put('/devices/hotel-admin/device/' + this.deviceData.uid + '/state', {
                value: this.deviceData.state.value > 0 ? this.deviceData.state.value : null
            })
                .catch((error) => {
                    if (this.disabledTimeout) {
                        clearTimeout(this.disabledTimeout);
                    }
                    this.deviceData.disabled = false;
                    this.deviceData.state = this.deviceStateOldValue;
                    this.loading = false;
                    console.log(error);
                });
        },
    },
}
</script>

<style lang="scss" scoped>
.warm-floor-slider.v-input__slider::v-deep {
    .v-slider.v-slider--horizontal {
        margin-top: 44px;

        .v-slider__track-container {
            height: 16px;
            border-radius: 30px;

            .v-slider__track-background.primary {
                border-radius: 30px;
                background-color: #F7F7F9 !important;
            }

            .v-slider__track-fill.primary {
                border-top-left-radius: 30px;
                border-bottom-left-radius: 30px;
                background-color: #FFFFFF !important;
                background: linear-gradient(180deg, #FFF4BC 0%, rgba(255, 132, 132, 0.54) 100%);
            }
        }
    }

    .v-slider__thumb.primary {
        background-color: #FFFFFF !important;
        background: linear-gradient(180deg, #FFF4BC 0%, rgba(255, 132, 132, 0.54) 99.99%, rgba(255, 168, 168, 0) 100%);
        height: 28px;
        width: 28px;
        border: 3px solid #FFFFFF !important;

        &::after,
        &::before {
            content: none;
        }

    }
    .v-slider__ticks-container .v-slider__tick {
        width: 0 !important;

        .v-slider__tick-label {
            top: -55px;
            transform: none;

            &::before {
                content: "";
                width: 4px;
                height: 0px;
                border: 1px solid #130F26;
                transform: rotate(90deg);
                position: absolute;
                top: 26px;
                left: 7px;
            }

            &::after {
                content: "°";
            }
        }

        &:last-child .v-slider__tick-label {
            transform: translateX(-50%);
        }
    }
}
</style>